import { Chip } from '@material-ui/core';
import { green, red } from '@material-ui/core/colors';

export const YesNoChip = ({ value }) => {
  const color = value === 'Yes' ? green : red;
  return (
    <Chip
      label={value}
      style={{
        fontWeight: 0,
        backgroundColor: color[200],
        color: color[900],
      }}
    />
  );
};